import { allPass, equals, propEq } from 'ramda'
import {
  SERVICE,
  PIN,
  CAN,
  CAN_INPUT,
  SIMPLE,
  TIMER,
  COMPLEX,
  QUERY_BOX_TYPES,
  ANALOG_INPUT,
  DIGITAL_INPUT,
  NATIVE_INPUT,
  SWITCH_INPUT,
} from 'utils/constants'

// Outputs
export const isNativeOutput = equals(SERVICE)
export const isPinOutput = equals(PIN)
export const isCanOutput = equals(CAN)
export const isBooleanOutput = propEq('isOutputBoolean', true)
export const isNonBooleanOutput = propEq('isOutputBoolean', false)
export const isSixteenBits = propEq('numberOfBits', 16)
export const isSixteenBitCanOutput = allPass([
  propEq('type', CAN),
  isSixteenBits,
])
export const isBooleanNativeOutput = allPass([
  propEq('type', SERVICE),
  isBooleanOutput,
])

export const isNonBooleanNativeOutput = allPass([
  propEq('type', SERVICE),
  isNonBooleanOutput,
])

// Conditions
export const isCanInput = equals(CAN_INPUT)
export const isSimpleQuery = equals(SIMPLE)
export const isTimer = equals(TIMER)
export const isLogicSet = equals(COMPLEX)
export const isTimerOrLogicSet = (queryType) => QUERY_BOX_TYPES.has(queryType)
export const isAnalogInput = equals(ANALOG_INPUT)
export const isDigitalInput = equals(DIGITAL_INPUT)
export const isNativeInput = equals(NATIVE_INPUT)
export const isSwitchInput = equals(SWITCH_INPUT)
export const isPinInput = (subType) =>
  [ANALOG_INPUT, DIGITAL_INPUT].includes(subType)

export const isLogicSetInput = propEq('queryType', COMPLEX)
export const isTimerInput = propEq('queryType', TIMER)
